import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../App.css";
import { toast } from "react-toastify";
import { ownerLogout, updateStoreTraffic } from "../redux/actions/authAction";
import { getStore, setSelectedBranch } from "../redux/actions/storeAction";
import { Modal, Dropdown } from "react-bootstrap";
import { io } from "socket.io-client";
import chill from "../assets/images/chill.svg";
import fire from "../assets/images/fire.svg";
import vibrant from "../assets/images/vibrant.svg";
import Dashboard from "./dashboard";
import { getBranchList } from "../redux/actions/branchAction";
import { useStore } from "../hooks/useStore";

const init = {
  timeArray: [
    "1:00:00 AM",
    "2:00:00 AM",
    "3:00:00 AM",
    "4:00:00 AM",
    "5:00:00 AM",
    "6:00:00 AM",
    "7:00:00 AM",
    "8:00:00 AM",
    "9:00:00 AM",
    "10:00:00 AM",
    "11:00:00 AM",
    "12:00:00 PM",
    "1:00:00 PM",
    "2:00:00 PM",
    "3:00:00 PM",
    "4:00:00 PM",
    "5:00:00 PM",
    "6:00:00 PM",
    "7:00:00 PM",
    "8:00:00 PM",
    "9:00:00 PM",
    "10:00:00 PM",
    "11:00:00 PM",
    "12:00:00 AM",
  ],
};

const Header = () => {
  const [iState] = useState(init);
  const { timeArray } = iState;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [trafficeShow, updatetrafficeShow] = useState(false);

  const handleTrafficClose = () => updatetrafficeShow(false);
  const handleTrafficShow = () => updatetrafficeShow(true);

  const storeid = JSON.parse(localStorage.getItem("ownerLogin"))?._id;
  // const isDefaultStore = JSON.parse(
  //   localStorage.getItem("ownerLogin"),
  // )?.isDefault;
  // console.log("isDefaultStore", isDefaultStore);

  const socketRef = useRef(null);
  const SOCKET_SERVER_URL = "https://bayin.app:4000";

  // ------------------ FIXED INTERVAL ------------------ //
  useEffect(() => {
    const interval = setInterval(() => {
      const timeNow = new Date().toLocaleTimeString();
      if (timeArray.includes(timeNow)) {
        handleTrafficShow();
      }
    }, 1000);

    return () => clearInterval(interval); // cleanup
  }, [timeArray]);

  // ------------------ GET STORE DATA ------------------ //
  // useEffect(() => {
  //   dispatch(getStore({})).then((res) => {
  //     if (res.status === 200) {
  //     }

  //     if (res.status === 503) {
  //       socketRef.current = io(SOCKET_SERVER_URL, {
  //         transports: ["websocket"],
  //         reconnection: true,
  //         reconnectionAttempts: Infinity,
  //         reconnectionDelay: 1000,
  //         reconnectionDelayMax: 5000,
  //       });

  //       socketRef.current.on("disconnect", () => {
  //         console.log("Socket disconnected");
  //       });

  //       socketRef.current.disconnect();
  //       localStorage.clear();
  //       navigate("/");
  //       toast.error("Logging out. User is already logged in somewhere.");
  //     }
  //   });
  // }, []);

  // ------------------ LOGOUT ------------------ //
  const handleLogout = () => {
    localStorage.removeItem("selectedBranchId");
    localStorage.removeItem("selectedBranchName");
    localStorage.removeItem("ownerIsMainBranch");
    localStorage.removeItem("ownerBranchCount");
    dispatch(setSelectedBranch(null, null));
    dispatch(ownerLogout()).then((res) => {
      if (res.status === 200) {
        toast.success(res.message);
        localStorage.clear();
        navigate("/");
      } else {
        toast.error(res.message);
        localStorage.clear();
        navigate("/");
      }
    });
  };

  // ------------------ SEND TRAFFIC ------------------ //
  const sendTraffice = (traffic) => {
    dispatch(updateStoreTraffic({ _id: storeid, traffic }));
    updatetrafficeShow(false);
  };

  const { branchList, loader: branchListLoader } = useSelector(
    (store) => store.branchReducer,
  );

  const { storeData } = useStore();
  const isMainBranch = storeData?.data?.isMainBranch;
  const branchCount = storeData?.data?.branchCount;

  // Persist flags to keep dropdown visible for owner when viewing sub-branches
  if (isMainBranch) {
    localStorage.setItem("ownerIsMainBranch", "true");
    localStorage.setItem("ownerBranchCount", (branchCount || 0).toString());
  }

  const showDropdown =
    (isMainBranch && branchCount > 0) ||
    (localStorage.getItem("ownerIsMainBranch") === "true" &&
      parseInt(localStorage.getItem("ownerBranchCount") || "0") > 0);

  const hasFetchedBranchList = useRef(false);

  useEffect(() => {
    if (!showDropdown) return;
    if (branchListLoader) return;
    if (branchList && branchList.data && branchList.data.result) {
      return;
    }
    if (hasFetchedBranchList.current) return;
    hasFetchedBranchList.current = true;
    dispatch(getBranchList({ adminVerificationStatus: "Approved" }));
  }, [
    isMainBranch,
    branchCount,
    showDropdown,
    branchList,
    branchListLoader,
    dispatch,
  ]);

  const ownerLogin = JSON.parse(localStorage.getItem("ownerLogin")) || {};
  const defaultBranchId = ownerLogin._id;

  const reduxSelectedBranchId = useSelector(
    (state) => state.store.selectedBranchId,
  );
  const reduxSelectedBranchName = useSelector(
    (state) => state.store.selectedBranchName,
  );

  const selectedBranchId = reduxSelectedBranchId || defaultBranchId;
  const selectedBranchName =
    reduxSelectedBranchName ||
    storeData?.data?.storeName ||
    ownerLogin.branchName ||
    "Store";

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    if (isMainBranch === false) {
      const mainBranchOnlyPaths = [
        "/my-store",
        "/edit-my-store",
        "/product-management",
        "/product-add",
        "/product-edit",
        "/branch-management",
        "/branch-add",
        "/branch-edit",
        "/branch-details",
        "/Report-management",
        "/report-transaction",
        "/report-product",
        "/report-order",
        "/report-admin",
      ];
      if (mainBranchOnlyPaths.some((path) => currentPath.startsWith(path))) {
        navigate("/dashboard");
      }
    } else if (isMainBranch === true) {
      if (currentPath.startsWith("/items")) {
        navigate("/dashboard");
      }
    }
  }, [isMainBranch, currentPath, navigate]);

  console.log(branchList, "branchList");

  const approvedBranches = branchList?.data?.result?.filter(
    (branch) => branch.adminVerificationStatus === "Approved"
  ) || [];

  return (
    <div>
      <div className="Header">
        <div
          className="Navigation"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {/* Branch Viewing Dropdown */}
          {showDropdown && (
            <div className="BranchSelector">
              <Dropdown>
                <Dropdown.Toggle
                  variant="light"
                  id="dropdown-branch"
                  style={{
                    borderRadius: "20px",
                    backgroundColor: "#e9eff6",
                    border: "none",
                    color: "#333",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    padding: "6px 16px",
                    boxShadow: "none",
                    marginRight: "50px",
                  }}
                >
                  <span
                    style={{
                      color: "#888",
                      fontSize: "11px",
                      fontWeight: "700",
                      letterSpacing: "0.5px",
                    }}
                  >
                    VIEWING
                  </span>
                  <i
                    className="fa fa-map-marker"
                    style={{ color: "#555", fontSize: "16px" }}
                  ></i>
                  {selectedBranchName}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  align="end"
                  popperConfig={{
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8],
                        },
                      },
                    ],
                  }}
                  style={{
                    width: "340px",
                    padding: "10px 0",
                    borderRadius: "12px",
                    border: "1px solid #e1e8ed",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                    marginTop: "8px",
                  }}
                >
                  <Dropdown.Item
                    onClick={(e) => {
                      e.preventDefault();
                      localStorage.removeItem("selectedBranchId");
                      localStorage.removeItem("selectedBranchName");
                      dispatch(setSelectedBranch(null, null));
                    }}
                    style={{
                      padding: "12px 20px",
                      backgroundColor:
                        selectedBranchId === defaultBranchId
                          ? "#edf3f9"
                          : "transparent",
                      transition: "background-color 0.2s",
                      whiteSpace: "normal",
                    }}
                    onMouseEnter={(e) => {
                      if (selectedBranchId !== defaultBranchId)
                        e.currentTarget.style.backgroundColor = "#f5f8fc";
                    }}
                    onMouseLeave={(e) => {
                      if (selectedBranchId !== defaultBranchId)
                        e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      }}
                    >
                      <i
                        className="fa fa-map-marker"
                        style={{
                          color: "#003a6b",
                          fontSize: "15px",
                          marginTop: "4px",
                        }}
                      ></i>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            fontWeight: "600",
                            color: "#222",
                            fontSize: "13.5px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          {ownerLogin.storeNumber ||
                            storeData?.data?.storeNumber ||
                            branchList?.data?.branches?.[0]?.store
                              ?.storeNumber ||
                            "B-001"}
                          {selectedBranchId === defaultBranchId && (
                            <i
                              className="fa fa-check"
                              style={{ color: "#003a6b", fontSize: "13px" }}
                            ></i>
                          )}
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#777",
                            marginTop: "2px",
                          }}
                        >
                          {ownerLogin.storeName ||
                            branchList?.data?.branches?.[0]?.store?.storeName ||
                            "Main Store"}
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#999",
                            marginTop: "2px",
                            wordBreak: "break-word",
                          }}
                        >
                          {ownerLogin?.address || storeData?.data?.address} ·
                          Full Access
                        </div>
                      </div>
                    </div>
                  </Dropdown.Item>

                  <div
                    style={{
                      padding: "12px 20px 6px 20px",
                      fontSize: "11px",
                      fontWeight: "700",
                      color: "#999",
                      letterSpacing: "0.8px",
                      textTransform: "uppercase",
                      borderTop: "1px solid #f0f0f0",
                      marginTop: "6px",
                    }}
                  >
                    Branches (View Only)
                  </div>

                  <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                    {approvedBranches.length > 0 ? (
                      approvedBranches.map((branch) => {
                        const isActive = selectedBranchId === branch._id;
                        return (
                          <Dropdown.Item
                            key={branch._id}
                            onClick={(e) => {
                              e.preventDefault();
                              localStorage.setItem(
                                "selectedBranchId",
                                branch._id,
                              );
                              localStorage.setItem(
                                "selectedBranchName",
                                branch.storeName,
                              );
                              dispatch(
                                setSelectedBranch(branch._id, branch.storeName),
                              );
                            }}
                            style={{
                              padding: "10px 20px",
                              backgroundColor: isActive
                                ? "#edf3f9"
                                : "transparent",
                              transition: "background-color 0.2s",
                              whiteSpace: "normal",
                            }}
                            onMouseEnter={(e) => {
                              if (!isActive)
                                e.currentTarget.style.backgroundColor = "#f5f8fc";
                            }}
                            onMouseLeave={(e) => {
                              if (!isActive)
                                e.currentTarget.style.backgroundColor =
                                  "transparent";
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "12px",
                              }}
                            >
                              <i
                                className="fa fa-map-marker"
                                style={{
                                  color: isActive ? "#003a6b" : "#999",
                                  fontSize: "15px",
                                  marginTop: "4px",
                                }}
                              ></i>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div
                                  style={{
                                    fontWeight: "600",
                                    color: "#222",
                                    fontSize: "13.5px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  {branch.storeNumber}
                                  {isActive && (
                                    <i
                                      className="fa fa-check"
                                      style={{
                                        color: "#003a6b",
                                        fontSize: "13px",
                                      }}
                                    ></i>
                                  )}
                                </div>
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "#777",
                                    marginTop: "2px",
                                  }}
                                >
                                  {branch.storeName || "N/A"}
                                </div>
                                {branch.address && (
                                  <div
                                    style={{
                                      fontSize: "11px",
                                      color: "#999",
                                      marginTop: "2px",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {branch.address}
                                  </div>
                                )}
                              </div>
                            </div>
                          </Dropdown.Item>
                        );
                      })
                    ) : (
                      <div
                        style={{
                          padding: "15px 20px",
                          fontSize: "13px",
                          color: "#999",
                          textAlign: "center",
                          fontWeight: "500",
                        }}
                      >
                        No Branches
                      </div>
                    )}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}

          <div className="Avater" style={{ margin: "0", marginLeft: "auto" }}>
            <Link
              to=""
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                textDecoration: "none",
                color: "#333",
                fontWeight: "600",
                fontSize: "13px",
                padding: "6px 14px",
                borderRadius: "30px",
                backgroundColor: "#f8fafd",
                border: "1px solid #e1e8ed",
                transition: "all 0.2s ease-in-out",
                boxShadow: "0 2px 5px rgba(0,0,0,0.04)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#eef4fa";
                e.currentTarget.style.borderColor = "#c6d4e2";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f8fafd";
                e.currentTarget.style.borderColor = "#e1e8ed";
              }}
            >
              <figure
                style={{
                  margin: 0,
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px solid #fff",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                }}
              >
                <img
                  src={storeData?.data?.logo}
                  alt=""
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </figure>
              <span
                style={{
                  maxWidth: "150px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {storeData?.data?.storeName}
              </span>
            </Link>

            <ul>
              <li>
                <figure>
                  <img src={storeData?.data?.logo} alt="" />
                </figure>
                <h4>{storeData?.data?.storeName}</h4>
              </li>

              <li>
                <button
                  onClick={handleLogout}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  <i className="fa fa-sign-out"></i> Logout
                </button>
              </li>
            </ul>
          </div>
        </div>

        <Modal
          show={trafficeShow}
          onHide={handleTrafficClose}
          className="ModalBox"
        >
          <Modal.Body>
            <div className="Decline">
              <button className="CloseModal" onClick={handleTrafficClose}>
                ×
              </button>

              <div className="StoreTrafic">
                <h4>Store Traffic</h4>
                <ul>
                  <li>
                    <button onClick={() => sendTraffice(50)}>
                      <img src={chill} alt="" /> <span>Chill</span>
                    </button>
                  </li>
                  <li>
                    <button onClick={() => sendTraffice(100)}>
                      <img src={vibrant} alt="" /> <span>Vibrant</span>
                    </button>
                  </li>
                  <li>
                    <button onClick={() => sendTraffice(150)}>
                      <img src={fire} alt="" /> <span>Fire</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Header;
